module.exports = __webpack_public_path__ + "img/hospital-floor.3005bf68.svg";